import { createFileRoute } from "@tanstack/react-router";
import { AgendaCalendarioPage } from "@/paginas/pg_agenda/agenda-calendario";

export const Route = createFileRoute("/_authenticated/agenda-calendario")({
  head: () => ({
    meta: [
      { title: "Agenda — Calendário — Milky Moo Palmares" },
      { name: "description", content: "Visualizar eventos da agenda." },
    ],
  }),
  component: AgendaCalendarioPage,
});
